import { render, staticRenderFns } from "./FileUploadMobile.vue?vue&type=template&id=42dc8477&"
import script from "./FileUploadMobile.vue?vue&type=script&lang=js&"
export * from "./FileUploadMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports